var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-204.86 26.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 3354.9 603.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -475,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m422.71 90.052v294.32c0 34.734 14.562 52.104 43.656 52.104h6.924v19.932h-156.37v-19.932h9.978c29.628 0 44.442-17.37 44.442-52.104v-193.15c0-35.274-12.54-52.896-37.554-52.896h-15.342v-19.92h6.138c30.126 0 57.474-9.444 81.99-28.35l16.14-0.0067zm258.28 262.12v30.654c0 34.242 11.976 51.366 36.018 51.366h9.948v19.896h-146.39v-19.896h11.508c24.018 0 36.024-16.878 36.024-50.58v-31.44h-147.17v-30.654l155.59-226.88h44.472v231.47h3.834c14.82 0 25.794-11.718 32.934-35.238h18.396l-9.198 61.314-45.972-7e-3zm-40.638-30.654v-193.13l-130.3 193.13h130.3z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana14);
export default __webpack_public_path__ + "static/media/mana14.84747ad05759c65356dc779217393171.svg";
export { ForwardRef as ReactComponent };